/**
 * Set up routing for all Node views
 *
 * For an example with protected routes, refer to /product/ProductRouter.js.jsx
 */

// import primary libraries
import React from 'react';
import { Route, Switch } from 'react-router-dom';

// import global components
import Base from "../../global/components/BaseComponent.js.jsx";
import YTRoute from '../../global/components/routing/YTRoute.js.jsx';

// import node views
import CreateNode from './views/CreateNode.js.jsx';
import NodeList from './views/NodeList.js.jsx';
import SingleNode from './views/SingleNode.js.jsx';
import UpdateNode from './views/UpdateNode.js.jsx';

class NodeRouter extends Base {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Switch>
        <YTRoute login={true} exact path="/nodes" component={NodeList} />
        <YTRoute login={true} exact path="/nodes/new" component={CreateNode} />
        <YTRoute login={true} exact path="/nodes/:nodeId" component={SingleNode}/>
        <YTRoute login={true} exact path="/nodes/:nodeId/update" component={UpdateNode}/>
      </Switch>
    )
  }
}

export default NodeRouter;



// WEBPACK FOOTER //
// modules/node/NodeRouter.js.jsx